import { Dangerous } from '@mui/icons-material';
import { Typography, Button, Grid } from '@mui/material';
import { useOktaAuth } from '@okta/okta-react';

import { settings } from 'config';
import { colors } from 'config/theme';
import { Background } from 'pages/styledComponents';

import { IconWrapper, ContentWrapper } from './styledComponents';

export const AccessDenied = (props: { message: string }) => {
  const { oktaAuth } = useOktaAuth();
  const signOut = async () => {
    await oktaAuth.signOut({
      clearTokensBeforeRedirect: true,
      postLogoutRedirectUri: settings.APP_ORIGINAL_URI,
      state: 'logged_out',
    });
  };
  const { message } = props;
  return (
    <Background>
      <Grid container spacing={3} sx={{ display: 'flex', mt: '10%' }}>
        <Grid item xs={4} sx={{ m: 'auto' }}>
          <IconWrapper>
            <Dangerous sx={{ color: colors.orange, fontSize: '70px' }} />
          </IconWrapper>
        </Grid>
        <Grid xs={8} item sx={{ color: 'white' }}>
          <ContentWrapper>
            <Typography variant='h3' sx={{ mb: 3, mt: 2 }}>
              Access Denied
            </Typography>
            <Typography variant='h5' sx={{ mb: 2 }}>
              {message}
            </Typography>
            <Button variant='contained' onClick={signOut}>
              LOG OUT
            </Button>
          </ContentWrapper>
        </Grid>
      </Grid>
    </Background>
  );
};
